import Sidebar from '@widgets/sidebar';
import Outlet from '@shared/uikit/outlet';
import useTheme from '@app/hooks/useTheme';
import Header from '@widgets/header';
import { useSelector } from 'react-redux';

const HomeLayout = () => {
  //const theme = useTheme()

  return (
    <div
      className={`h-screen w-screen bg-[#141316] text-white flex px-[21px]`}
      contentEditable={false}
    >
      <Sidebar />
      <div className="w-full overflow-auto ml-[25px]">
        <Header />
        <div className="home-layout mt-[90px] mb-[30px]">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default HomeLayout;
